import { useMemo } from 'react';
import {
  StyledColumnChartSkeleton,
  StyledColumnSkeleton
} from './ColumnChartSkeleton.style';
import { random } from 'lodash';

const ColumnChartSkeleton = ({ total = 8, sizes = [] }) => {
  const totalColumns = sizes?.length || total;
  const Columns = useMemo(() => {
    return Array.from({ length: totalColumns }).map((_, idx) => {
      const size = sizes[idx] ?? random(10, 90);
      return <StyledColumnSkeleton key={idx} size={size} />;
    });
  }, [sizes, totalColumns]);

  return <StyledColumnChartSkeleton>{Columns}</StyledColumnChartSkeleton>;
};

export default ColumnChartSkeleton;
